import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import FlatFeeMilestone from '../../entities/flatFeeMilestone';
import Invoice from '../../entities/invoice';
import Task from '../../entities/task';
export function deleteFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = flatFeeMilestone.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('flatFeeMilestoneBucket', flatFeeMilestone.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeMilestoneBucket === flatFeeMilestone.id) {
_task.flatFeeMilestoneBucket = null;
_task.flatFeeBucket = null;
}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



flatFeeMilestone.status = 'D';
flatFeeMilestone.addedOn = newHRTimestamp();
flatFeeMilestone.addedBy = getCurrentUserId();
flatFeeMilestone.importSource = targetImportSource;
flatFeeMilestone.importId = mergeId;
store.dispatch(Actions.FlatFeeMilestoneActions.removeFlatFeeMilestoneQueue(flatFeeMilestone));
}
export function replaceFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone, replaceWith: FlatFeeMilestone, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = flatFeeMilestone.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('flatFeeMilestoneBucket', flatFeeMilestone.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.flatFeeMilestoneBucket === flatFeeMilestone.id) {
_task.flatFeeMilestoneBucket = replaceWith.id;
_task.flatFeeBucket = null;
}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});



return flatFeeMilestone;
}
export function deleteImpactFlatFeeMilestone(flatFeeMilestone: FlatFeeMilestone) {
const impacts: string[] = [];
const state = store.getState();
const invoiceFlatFeeMilestoneIdsImpact = state.invoices.getMappingFor('flatFeeMilestoneIds', flatFeeMilestone.id).filter(invoice => invoice.status !== 'D');
invoiceFlatFeeMilestoneIdsImpact.forEach(() => impacts.push('invoices'));
const taskFlatFeeMilestoneBucketImpact = state.tasks.getMappingFor('flatFeeMilestoneBucket', flatFeeMilestone.id).filter(task => task.status !== 'D');
taskFlatFeeMilestoneBucketImpact.forEach(() => impacts.push('tasks'));



return util.countDistinct(impacts);
}
